import { render, staticRenderFns } from "./FormEmpresa.vue?vue&type=template&id=7dffbd60"
import script from "./FormEmpresa.vue?vue&type=script&lang=js"
export * from "./FormEmpresa.vue?vue&type=script&lang=js"
import style0 from "./FormEmpresa.vue?vue&type=style&index=0&id=7dffbd60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports